// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3SwZY","checkboxCol":"Table_checkboxCol__2T8eJ","emailCol":"Table_emailCol__1iKlh","actionCol":"Table_actionCol__1RbLV"};